import { createActions, createReducer } from 'reduxsauce'

import EventosContratoService from '../../servicos/EventosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaEventosContratoInicio: [],
    buscaEventosContratoSucesso: ['eventosContrato'],
    buscaEventosContratoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaEventosContrato = filtro => {
    return dispatch => {
        dispatch(Creators.buscaEventosContratoInicio())
        let serv = new EventosContratoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaEventosContratoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaEventosContratoErro(error)))
    }
}

const buscaEventosContratoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaEventosContratoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaEventosContratoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.eventosContrato, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EVENTOS_CONTRATO_INICIO]: buscaEventosContratoInicio,
    [Types.BUSCA_EVENTOS_CONTRATO_ERRO]: buscaEventosContratoErro,
    [Types.BUSCA_EVENTOS_CONTRATO_SUCESSO]: buscaEventosContratoSucesso,
})
